export { StarFill as default } from './StarFill';
